module.exports = __webpack_public_path__ + "img/shop-v1-blurred.54175a9e.jpg";